module.exports = __webpack_public_path__ + "img/telegram.d15e65e7.png";